import { render, staticRenderFns } from "./StatusComitenteSelect.vue?vue&type=template&id=ed59e7d0&"
import script from "./StatusComitenteSelect.vue?vue&type=script&lang=js&"
export * from "./StatusComitenteSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports